module.exports = __webpack_public_path__ + "img/transfer-buyer-docs.c499d9f3.jpg";